import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FilterInputComponent } from './filter-input.component';

@NgModule({
    imports: [
        CommonModule,
        MatInputModule,
        MatIconModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatSelectModule,
        ReactiveFormsModule,
        FilterInputComponent
    ],
    exports: [FilterInputComponent]
})
export class FilterInputModule { }
